import { render, staticRenderFns } from "./PropertyLiabilityCalculator.vue?vue&type=template&id=75fa060c"
import script from "./PropertyLiabilityCalculator.vue?vue&type=script&lang=ts"
export * from "./PropertyLiabilityCalculator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports